import { render } from "./AuthLayout.vue?vue&type=template&id=b9d6265a"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=b9d6265a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__